
<span class="sdv-icon">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
  >
    <path :d="svg" />
  </svg>
</span>
